module.exports = __webpack_public_path__ + "static/hijo2_2-1fe7e748f40ddba0f359726b076f2cee.jpg";